import { App } from "./App";

export class HANavigationApp extends App {

    public updateInfo(data: Map<string, any>) {
    }
}
